<template>
  <div :class="`alert alert-${type} p-3 d-flex align-items-center w-100`">
    <img src="/defaults/triangle.svg" alt="triangle" v-if="type == 'warning' || type == 'danger'">
    <img src="/defaults/success.svg" alt="triangle" v-if="type == 'success'">
    <img src="/defaults/info.svg" alt="triangle" v-if="type == 'info'">

    <div class="ms-3">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: ["type"],
};
</script>
